import Select from '@ben/orion/deprecated-select';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import { Controller, useFormContext } from 'react-hook-form';
import { fieldCannotBeBlankErrorMessage } from '../../shared/constants';

const DYNAMIC_ENROLLMENT_END_DATE_OPTIONS = [
  {
    label: '24 months from start date',
    key: 'AT_24_MONTHS_FROM_START_DATE',
  },
  {
    label: '12 months from start date',
    key: 'AT_12_MONTHS_FROM_START_DATE',
  },
  {
    label: '6 months from start date',
    key: 'AT_6_MONTHS_FROM_START_DATE',
  },
  {
    label: '4 months from start date',
    key: 'AT_4_MONTHS_FROM_START_DATE',
  },
  {
    label: '3 months from start date',
    key: 'AT_3_MONTHS_FROM_START_DATE',
  },
  {
    label: '2 months from start date',
    key: 'AT_2_MONTHS_FROM_START_DATE',
  },
  {
    label: '1 month from start date',
    key: 'AT_1_MONTH_FROM_START_DATE',
  },
  {
    label: 'At current year end',
    key: 'AT_CURRENT_YEAR_END',
  },
  {
    label: 'At loan term end',
    key: 'AT_LOAN_TERM_END',
  },
];

export const DynamicEnrollmentEndConfig = () => {
  const { control } = useFormContext<IModularBenefitDetail>();

  return (
    <Controller
      name="enrollmentConfig.dynamicEnrollmentEndDate"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          {...field}
          name="Dynamic enrolment end date"
          options={DYNAMIC_ENROLLMENT_END_DATE_OPTIONS}
          required
          errorMessage={fieldState.error?.message}
          hasError={!!fieldState.error}
        />
      )}
      rules={{
        required: fieldCannotBeBlankErrorMessage,
      }}
    />
  );
};
